import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const HtmlTooltip = styled(({ className, ...props }) => (<Tooltip {...props} classes={{ popper: className }}/>))(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: theme.typography.pxToRem(20),
      border: "1px solid #dadde9",
    },
  }));

export default function CustomTooltip({ title, children }) {
  return (<HtmlTooltip title={title} slotProps={{
    popper: {
      modifiers: [
        {
          name: "offset", options: {
            offset: [0, -14],
          },
        }],
    },
  }}>{children}</HtmlTooltip>);
}